import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import useTheme from '../hooks/useTheme'

interface Props {
	invoiceNumber: string | null
	onClose: () => void
	isLoading: boolean
	handleSubmit: () => void
}

const DeleteInvoiceModal: React.FC<Props> = ({
	invoiceNumber,
	onClose,
	isLoading,
	handleSubmit,
}) => {
	const theme = useTheme()
	return (
		<Modal
			style={{ '--bs-modal-color': 'var(--bs-body-color)' } as any}
			data-bs-theme={theme}
			show={!!invoiceNumber}
			onHide={onClose}
		>
			<div>
				<Modal.Header closeButton>
					<Modal.Title>Видалення заявки</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p>
						Ви впевненні що хочете видалити заявку <br />
						<strong>{invoiceNumber}</strong>?
					</p>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose} variant="secondary">
						Закрити
					</Button>
					<Button onClick={handleSubmit} disabled={isLoading} variant="danger">
						Видалити
						{isLoading && (
							<Spinner className="ms-1" animation="border" size="sm" />
						)}
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	)
}

export default DeleteInvoiceModal

